/** Public, non-secret settings (from `terraform output` in infra/terraform/envs/prod). */
export const config = {
  apiUrl: import.meta.env.VITE_API_URL ?? "https://api.roxpacer.com",
  auth: {
    domain: import.meta.env.VITE_AUTH_DOMAIN ?? "https://auth.roxpacer.com",
    issuer:
      import.meta.env.VITE_AUTH_ISSUER ??
      "https://cognito-idp.us-east-1.amazonaws.com/us-east-1_bTd5rF9C0",
    clientId: import.meta.env.VITE_AUTH_CLIENT_ID ?? "1u39nenef2fiup6m0lunvjepba",
  },
};
